import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { IconButton, Tooltip } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import { useLanguageSettings } from 'views/Settings';

const useStyles = makeStyles(theme => ({
    closeIcon: {
        paddingTop: '16px',
        paddingRight: '16px'
    }
}));

const CloseIcon = props => {
    const {
        onClickClose,
        style
    } = props;

    const classes = useStyles();

    const { languageContent, getLanguageContent } = useLanguageSettings();
    const [componentContent, setComponentContent] = React.useState(null);

    React.useEffect(() => {
        if (languageContent) {
            setComponentContent(getLanguageContent("components", "closeIcon"));
        }
    }, [languageContent]);

    return (
        <div className={classes.closeIcon} style={style}>
            <Tooltip title={componentContent?.closeIconTitle || `Close`} arrow>
                <IconButton onClick={onClickClose}>
                    <Close color="error" />
                </IconButton>
            </Tooltip>
        </div>
    );
};

CloseIcon.propTypes = {
    onClickClose: PropTypes.func,
    style: PropTypes.object
};

export default CloseIcon;